import styled from 'styled-components';

interface Props {
  hasHeaderInfo: boolean
}

export const Container = styled.div<Props>`
  background-color: ${props => props.theme.colors.card_300};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ hasHeaderInfo }) => (hasHeaderInfo ? 'space-between' : 'flex-end')};
  box-shadow: 0 3px 5x -2px #666666;
  padding: 10px;
  border-color: ${props => props.theme.colors.border_grey} !important;
  border-bottom: 1px solid;
  border-right: 1px solid;
`;

export const SwitchContainer = styled.div`
  padding-inline: 20px;
`;

export const ContainerIconText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const ContainerIcon = styled.div`

`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ContainerText = styled.div`
  height: 55px;
  width: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PageTitle = styled.div`
  margin-left: 10px;
  margin-right: 10px;
  font-size: smaller;
`;

export const AvatarContainer = styled.div`
  align-self: flex-end;
`;

export const DevLine = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  margin: 5px;
  padding: 5px;
`;
